import { z } from "zod"

/**
 * Payment receipts (T467, PRD R2.11): one per payment, own `RCT-` sequence, voided never
 * deleted. Web only. Named payment-receipts because `receipts.test.ts` is the expense receipts
 * (documents) contract. Request strict, stored/response lenient.
 */

export const RECEIPT_NUMBER_PREFIX = "RCT-"

export const receiptSchema = z.object({
  id: z.uuid(),
  organisation_id: z.uuid(),
  invoice_id: z.uuid(),
  payment_id: z.uuid(),
  sequence_no: z.number().int(),
  number: z.string(),
  issued_on: z.string().date(),
  voided_at: z.string().datetime({ offset: true }).nullable().default(null),
  pdf_storage_path: z.string().nullable().default(null),
  created_at: z.string().datetime({ offset: true }),
  updated_at: z.string().datetime({ offset: true }),
})

export type Receipt = z.infer<typeof receiptSchema>

export const issueReceiptRequestSchema = z.strictObject({ payment_id: z.uuid() })

export type IssueReceiptRequest = z.input<typeof issueReceiptRequestSchema>
